import { ITableMetrics, IMetricsType, IVisualisItem } from '../typings';

export const RANGE_PICKER_DEFAULT_TYPE = 'month';

export const RANGE_PICKER_DEFAULT_START_TIME = '2017-01-01';

export const DEFAULT_PAGE_SIZE_OPTIONS = [10, 20, 50];

export const DEFAULT_PAGE_SIZE = DEFAULT_PAGE_SIZE_OPTIONS[0];

export const DEFAULT_PAGE_INDEX = 1;

export const TABLE_UNIQUE_KEY = 'subGenre';
export const TABLE_UNIQUE_KEYS = 'sub_genre';
export const DEFALUT_SORT_ORDER = 'desc';

export const DEFAULT_SOURCE_TYPE = 'mainsub';

export const GENRE_SEGMENT_OPTIONS = [
  { text: 'dbi_main_genre', value: 'main' },
  { text: 'dbi_sub_genre', value: 'sub' },
  { text: 'dbi_main_sub_genre', value: 'mainsub' },
];

export const VISUALIS_ICONS: IVisualisItem[] = [
  {
    id: 1,
    context: 'dbi_line_chart',
    contextEn: 'Folding Line Diagram',
    contextCn: '折线图',
    icon: 'discount-chart',
    value: 'line',
  },
  {
    id: 2,
    context: 'dbi_tree_map',
    contextEn: 'Rectangular Tree Diagram',
    contextCn: '矩形树图',
    icon: 'chart-treemap',
    value: 'treemap',
  },
];

export const TABLE_METRICS_MAP: IMetricsType = {
  rev: 'Revenue($)',
  download: 'Downloads',
  digital_rev: 'Digital Revenue($)',
  phy_rev: 'Physical Revenue($)',
  total_rev: 'Total Revenue($)',
};

export const METRICS_LAST_MAP: IMetricsType = {
  rev: 'pre_rev',
  download: 'pre_download',
  digital_rev: 'pre_dig_rev',
  phy_rev: 'pre_phy_rev',
};

export const TABLE_METRICS: ITableMetrics = {
  mobile: {
    default: 'rev',
    list: ['rev', 'download'],
    source: ['appannie', 'appannie'],
    genreSource: 'appannie',
  },
  pc: {
    default: 'digital_rev',
    list: ['digital_rev', 'phy_rev'],
    source: ['mscience', 'npd'],
    genreSource: 'iegg',
  },
  console: {
    default: 'digital_rev',
    list: ['digital_rev', 'phy_rev'],
    source: ['mscience', 'npd'],
    genreSource: 'iegg',
  },
  total: {
    default: 'total_rev',
    list: ['total_rev', 'download'],
    source: ['', 'appannie'],
    genreSource: 'iegg',
    // 针对某个字段的计算属性,值等于数组中所有字段值相加
    computedSum: {
      total_rev: ['rev', 'digital_rev', 'phy_rev'],
    },
    // 排序时tooltip下拉显示的文本
    simpleTitle: {
      total_rev: 'Revenue($)',
    },
  },
};

export const TABLE_SEARCH_PLACEHOLDERS: {
  [key: string]: string;
} = {
  games: 'dbi_genre_profile_search_games',
  countries: 'dbi_genre_profile_search_countries',
  companies: 'dbi_genre_profile_search_companies',
};

export const GRANULARITY_MAP = {
  daily: 'dau',
  weekly: 'wau',
  monthly: 'mau',
};
